import { PartyFieldLabel } from "@/components/parties/PartyFormSection";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import {
  partyTypeOptionsForRole,
  type PartyRole,
} from "@/lib/parties/partyTypes";

type PartyTypeForRole<R extends PartyRole> = "all" | R;

type Props<R extends PartyRole> = {
  role: R;
  value: PartyTypeForRole<R>;
  onChange: (value: PartyTypeForRole<R>) => void;
  disabled?: boolean;
};

export function PartyTypeField<R extends PartyRole>({ role, value, onChange, disabled }: Props<R>) {
  const options = partyTypeOptionsForRole(role);

  return (
    <div className="space-y-2">
      <PartyFieldLabel>Type</PartyFieldLabel>
      <Select
        value={value}
        onValueChange={(next) => onChange(next as PartyTypeForRole<R>)}
        disabled={disabled}
      >
        <SelectTrigger className="glass-input h-10">
          <SelectValue placeholder="Select type" />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
